import React, { useState } from 'react';
import { Lock, User, AlertCircle } from 'lucide-react';
import { API_BASE_URL } from '../../config';

const LoginForm = ({ onLogin }) => {
    const [authData, setAuthData] = useState({ login: '', password: '' });
    const [authError, setAuthError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setAuthError('');

        try {

            const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    login: authData.login,
                    password: authData.password
                }),
                credentials: 'include'
            });

            if (response.ok) {
                onLogin();
                setAuthError('');
            }
            else {
                if (response.status === 401) {
                    setAuthError('Неверный логин или пароль');
                }
                else {
                    setAuthError('При авторизации произошла ошибка');
                }
            }
        }
        catch (error) {
            console.error('auth error:', error);
            setAuthError('При авторизации произошла ошибка');
        }
    };

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 font-sans text-slate-900">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl overflow-hidden">
                <div className="bg-slate-900 p-8 text-center">
                    <div className="mx-auto w-16 h-16 bg-gradient-to-tr from-indigo-500 to-cyan-400 rounded-full flex items-center justify-center mb-4 text-white shadow-lg">
                        <Lock size={32} />
                    </div>
                    <h1 className="text-2xl font-bold text-white">ЛОГО</h1>
                </div>

                <div className="p-8">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-2">Логин</label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
                                    <User size={20} />
                                </div>
                                <input
                                    type="text"
                                    className="w-full pl-10 pr-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                    placeholder="Введите логин (admin)"
                                    value={authData.login}
                                    onChange={(e) => setAuthData({ ...authData, login: e.target.value })}
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-2">Пароль</label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
                                    <Lock size={20} />
                                </div>
                                <input
                                    type="password"
                                    className="w-full pl-10 pr-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all"
                                    placeholder="Введите пароль (admin)"
                                    value={authData.password}
                                    onChange={(e) => setAuthData({ ...authData, password: e.target.value })}
                                />
                            </div>
                        </div>

                        {authError && (
                            <div className="p-3 bg-rose-50 text-rose-600 rounded-lg text-sm flex items-center gap-2">
                                <AlertCircle size={16} />
                                {authError}
                            </div>
                        )}

                        <button
                            type="submit"
                            className="w-full bg-indigo-600 text-white py-3 rounded-lg font-bold hover:bg-indigo-700 transition-colors shadow-lg shadow-indigo-200"
                        >
                            Войти
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;